import React, { Component } from 'react';

export class ScannedItemsCart extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var scannedItemsCart = this.props.scannedItemsCart;
        var undoPickFunction = this.props.undoPick;
        var usesBins = this.props.usesBins;
        return (
            <div>
                <h1>Putaway Cart</h1>
                 {
                    scannedItemsCart.length > 0 &&
                    <div>
                        <table className="scannedToteTable">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Item</th>
                                    <th>{usesBins ? "Bin" : "Slot"}</th>
                                </tr>
                            </thead>
                            <tbody>
                            {scannedItemsCart.map(function (scannedItem, idx) {
                                return (
                                    <tr key={idx}>
                                        <td className="undo-button"><button onClick={() => { undoPickFunction(scannedItem) }}>Undo</button></td>
                                        <td>{scannedItem.item}</td>
                                        <td>{usesBins ? scannedItem.binText : scannedItem.slot}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        );
    }
}
